import {Section} from "./Section";
import {Order} from "../Order";
import {formatNumber} from "../../../helpers/format-number";

export class ShippingSection extends Section {

  constructor(sectionElement, shippingInfos) {
    super(sectionElement);

    this.previousSectionButton = this.element.querySelector('[data-button="prev"]');
    this.nextSectionButton = this.element.querySelector('[data-button="next"]');
    this.shippingInfos = shippingInfos;
    this.formElement = this.element.querySelector('form');
    this.defaultFormData = Object.fromEntries(new FormData(this.formElement));

    ShippingSection.defaultFormData = this.defaultFormData;
    ShippingSection.shippingInfos = this.shippingInfos;
    ShippingSection.element = this.element;
    ShippingSection.formElement = this.formElement;
  }

  static get maxShippingWidth() {
    const PRODUCTS = Order.products;
    const MAX_SIZES = [];

    PRODUCTS.forEach(product => {
      const TEMPLATE = product.pageInfos.productId;
      if (TEMPLATE === 'order-product-vertical-slat') MAX_SIZES.push(109);
      else if (TEMPLATE === 'order-product-balcony-covering') MAX_SIZES.push(parseInt(product.formDataObject.height));
      else {
        const WIDTH_VALUE = product.formDataObject.width;
        const HAS_MAX_WIDTH = WIDTH_VALUE.includes('_max');
        const WIDTH = HAS_MAX_WIDTH ? product.formDataObject.widthMax : WIDTH_VALUE;

        MAX_SIZES.push(parseInt(WIDTH));
      }
    })

    const VALUE = MAX_SIZES.length > 0 ? Math.max(...MAX_SIZES) : 0
    let TOGGLE_KEY = 'small';
    if (VALUE > 185 && VALUE <= 290) TOGGLE_KEY = 'big';
    if (VALUE > 290) TOGGLE_KEY = 'extra';

    return {
      value: VALUE,
      toggleKey: TOGGLE_KEY
    };
  }

  static get formDataObject() {
    return Object.fromEntries(new FormData(ShippingSection.formElement));
  }

  static updateFormFields() {
    const SHIPPING_DATA = Order.shipping;
    const FORM_FIELDS = ShippingSection.formElement.elements;
    const TOGGLE_ELEMENTS = ShippingSection.element.querySelectorAll('[data-toggled-by]');
    const SPECIAL_TOGGLE = ShippingSection.element.querySelector('[data-special-toggle]');
    const FILTERED_TOGGLE_ELEMENTS = Array.from(TOGGLE_ELEMENTS).filter(element => {
      return !element.getAttribute('data-toggled-by').includes('big') && !element.getAttribute('data-toggled-by').includes('small')
    })

    Section.updateFormFields(FORM_FIELDS, SHIPPING_DATA);

    for (const FORM_FIELD of FORM_FIELDS) {
      if (FORM_FIELD.name === 'packageStamp') {
        const SPECIAL_TOGGLE_VALUES = SPECIAL_TOGGLE.getAttribute('data-special-toggle').split(',')

        if (SPECIAL_TOGGLE_VALUES.includes(FORM_FIELD.value)) {
          SPECIAL_TOGGLE.classList.remove('d-none');
        } else SPECIAL_TOGGLE.classList.add('d-none');
      }

      if (FORM_FIELD.hasAttribute('data-toggle') && FORM_FIELD.checked) {
        const TOGGLE_KEY = FORM_FIELD.getAttribute('data-toggle');

        FILTERED_TOGGLE_ELEMENTS.forEach(toggleElement => {
          if (toggleElement.getAttribute('data-toggled-by').includes(TOGGLE_KEY)) {
            toggleElement.classList.remove('d-none');
          } else toggleElement.classList.add('d-none');
        });
      }
    }
  }

  static updateSectionElements() {
    const SHIPPING_WIDTH = ShippingSection.maxShippingWidth;
    const TOGGLE_ELEMENTS = Array.from(ShippingSection.element.querySelectorAll('[data-toggled-by]'));

    const SHIPPING_PRICES = ShippingSection.priceData;

    const FILTERED_TOGGLE_ELEMENTS = TOGGLE_ELEMENTS.filter(element => {
      return element.getAttribute('data-toggled-by').includes('big') || element.getAttribute('data-toggled-by').includes('small') || element.getAttribute('data-toggled-by').includes('extra');
    })

    const TOGGLE_STRING = SHIPPING_WIDTH.toggleKey
    let isChecked = false;

    FILTERED_TOGGLE_ELEMENTS.forEach(element => {
      if (element.getAttribute('data-toggled-by').includes(TOGGLE_STRING)) {
        if (!isChecked) {
          const RADIO_INPUT = element.querySelector('input')
          const CHANGE_EVENT = new Event('change');

          RADIO_INPUT.checked = true;
          RADIO_INPUT.dispatchEvent(CHANGE_EVENT);

          isChecked = true;
        }
        element.classList.remove('d-none');
      } else element.classList.add('d-none');
    });

    /** GET SHIPPING OPTION DATA */
    const SHIPPING_ALL_INCLUSIVE_ELEMENT = ShippingSection.formElement.querySelector('[id="shipping_allInclusive"]');
    const SHIPPING_ALL_INCLUSIVE_PRICE_EURO = formatNumber(SHIPPING_PRICES.shippingOptionPrice);
    const SHIPPING_ALL_INCLUSIVE_PRICE_TEXT = `(${SHIPPING_ALL_INCLUSIVE_PRICE_EURO} €)`;

    /** GET SHIPPING PACKAGE DATA */
    const SHIPPING_PACKAGE_ELEMENT = ShippingSection.formElement.querySelector('[id="shipping_package"]');
    // const SHIPPING_PACKAGE_PRICE_EURO = formatNumber(SHIPPING_PRICES.packageMinPrice);
    // const SHIPPING_PACKAGE_PRICE_TEXT = `(ab ${SHIPPING_PACKAGE_PRICE_EURO} €)`;
    const SHIPPING_PACKAGE_PRICE_TEXT = `(siehe unten)`;

    /** GET DIY EXTRA DATA */
    const SHIPPING_DIY_EXTRA_ELEMENT = ShippingSection.formElement.querySelector('[id="shipping_diyExtra"]');
    const SHIPPING_DIY_EXTRA_PRICE_EURO = formatNumber(SHIPPING_PRICES.diyExtraPrice);

    const SHIPPING_DIY_EXTRA_PRICE_TEXT = `(${SHIPPING_DIY_EXTRA_PRICE_EURO} €)`;

    /** GET RETOURE DATA */
    const SHIPPING_RETOURE_ELEMENT = ShippingSection.formElement.querySelector('[id="shipping_retoure"]');
    const SHIPPING_RETOURE_PRICE_EURO = SHIPPING_PRICES.retourePrice > 0 ? formatNumber(SHIPPING_PRICES.retourePrice) : 0;

    const SHIPPING_RETOURE_PRICE_TEXT = parseFloat(SHIPPING_RETOURE_PRICE_EURO) > 0 ? `(${SHIPPING_RETOURE_PRICE_EURO} €)` : `auf Anfrage`;

    if (SHIPPING_ALL_INCLUSIVE_ELEMENT) ShippingSection.#fillLabelSlot(SHIPPING_ALL_INCLUSIVE_ELEMENT, SHIPPING_ALL_INCLUSIVE_PRICE_TEXT);
    if (SHIPPING_PACKAGE_ELEMENT) ShippingSection.#fillLabelSlot(SHIPPING_PACKAGE_ELEMENT, SHIPPING_PACKAGE_PRICE_TEXT);
    if (SHIPPING_DIY_EXTRA_ELEMENT) ShippingSection.#fillLabelSlot(SHIPPING_DIY_EXTRA_ELEMENT, SHIPPING_DIY_EXTRA_PRICE_TEXT);
    if (SHIPPING_RETOURE_ELEMENT) ShippingSection.#fillLabelSlot(SHIPPING_RETOURE_ELEMENT, SHIPPING_RETOURE_PRICE_TEXT);
  }

  static #fillLabelSlot(inputElement, text) {
    const SHIPPING_LABEL_ELEMENT = inputElement.closest('[for]');
    const SHIPPING_VALUE_ELEMENT = SHIPPING_LABEL_ELEMENT.querySelector('.label-slot');

    SHIPPING_VALUE_ELEMENT.innerText = text
  }

  static getShippingStampName(optionKey) {
    const PACKAGE_NAME_OBJECT = {
      package_surcharge_dhl: 'Paket-Marke bis 120cm (DHL) Shopabgabe',
      package_surcharge_gls: 'Paket-Marke bis 200cm (GLS) Shopabgabe',
      package_surcharge_gls_pickup: 'Paket-Abholung bis 120cm (GLS)',
      package_surcharge_dhl_pickup: 'Paket-Abholung bis 200cm (GLS)'
    }

    return PACKAGE_NAME_OBJECT[optionKey];
  }

  static getShippingOptionName(optionKey) {

    const SERVICE_NAME_OBJECT = {
      allInclusive: 'Sorglos-Versand-Paket',
      package: 'Paketmarke für eigene Verpackung',
      diy: 'Versand in Eigenregie',
      diyExtra: 'Versand in Eigenregie + Verpackungsservice',
      delivery: 'Persönliche Verbringung'
    }

    return SERVICE_NAME_OBJECT[optionKey];

  }

  static get priceData() {

    const SHIPPING_INFOS = ShippingSection.shippingInfos;
    const FORM_DATA = ShippingSection.formDataObject;

    let currentShippingPriceTotal = 0;

    if (FORM_DATA.service === 'allInclusive') {
      currentShippingPriceTotal += ShippingSection.#allInclusivePrice + ShippingSection.#stretchFilmPrice
    } else if (FORM_DATA.service === 'package') {
      currentShippingPriceTotal = parseInt(SHIPPING_INFOS[FORM_DATA.packageStamp]);
    } else if (FORM_DATA.service === 'diyExtra') {
      currentShippingPriceTotal = ShippingSection.#diyExtraPrice;
    }

    return {
      currentShippingName: ShippingSection.getShippingOptionName(FORM_DATA.service),
      currentShippingNameKey: FORM_DATA.service,
      currentShippingPrice: currentShippingPriceTotal,
      currentShippingStamp: ShippingSection.getShippingStampName(FORM_DATA.packageStamp),
      currentShippingStampKey: FORM_DATA.packageStamp,
      currentStretchFilms: parseInt(FORM_DATA.stretchFilm),
      shippingOptionPrice: ShippingSection.#allInclusivePrice,
      stretchFilmPrice: ShippingSection.#stretchFilmPrice,
      packageMinPrice: ShippingSection.#packagePrice,
      diyExtraPrice: ShippingSection.#diyExtraPrice,
      retourePrice: ShippingSection.#retourePrice
    };
  }

  static get #allInclusivePrice() {
    const SHIPPING_WIDTH = ShippingSection.maxShippingWidth;
    const SHIPPING_INFOS = ShippingSection.shippingInfos

    let ALL_INCLUSIVE_PRICE = parseInt(SHIPPING_INFOS.all_inclusive_surcharge_110);
    if (SHIPPING_WIDTH.value > 110 && SHIPPING_WIDTH.value <= 135) {
      ALL_INCLUSIVE_PRICE = parseInt(SHIPPING_INFOS.all_inclusive_surcharge_135);
    } else if (SHIPPING_WIDTH.value > 135 && SHIPPING_WIDTH.value <= 185) {
      ALL_INCLUSIVE_PRICE = parseInt(SHIPPING_INFOS.all_inclusive_surcharge_185);
    }

    return ALL_INCLUSIVE_PRICE;
  }

  static get #stretchFilmPrice() {
    const SHIPPING_INFOS = ShippingSection.shippingInfos
    const STRETCH_FILM_PRICE = parseInt(SHIPPING_INFOS.stretch_film_cost);
    const STRETCH_FILM_QUANTITY = parseInt(ShippingSection.formDataObject.stretchFilm);

    return STRETCH_FILM_PRICE * STRETCH_FILM_QUANTITY;
  }

  static get #packagePrice() {
    const SHIPPING_INFOS = ShippingSection.shippingInfos
    const PACKAGE_SURCHARGES = [
      parseInt(SHIPPING_INFOS.package_surcharge_dhl),
      parseInt(SHIPPING_INFOS.package_surcharge_gls),
      parseInt(SHIPPING_INFOS.package_surcharge_gls_pickup),
      parseInt(SHIPPING_INFOS.package_surcharge_dhl_pickup)
    ];
    return Math.min(...PACKAGE_SURCHARGES);
  }

  static get #diyExtraPrice() {
    const SHIPPING_WIDTH = ShippingSection.maxShippingWidth;
    const SHIPPING_INFOS = ShippingSection.shippingInfos

    return SHIPPING_WIDTH.value <= 235 ? parseInt(SHIPPING_INFOS.diy_extra_surcharge_235) : parseInt(SHIPPING_INFOS.diy_extra_surcharge_285);
  }

  static get #retourePrice() {
    const SHIPPING_WIDTH = ShippingSection.maxShippingWidth;
    const SHIPPING_INFOS = ShippingSection.shippingInfos

    let RETOURE_PRICE = parseInt(SHIPPING_INFOS.retoure_surcharge_110);
    if (SHIPPING_WIDTH.value > 110 && SHIPPING_WIDTH.value < 136) {
      RETOURE_PRICE = parseInt(SHIPPING_INFOS.retoure_surcharge_135);
    } else if (SHIPPING_WIDTH.value > 135 && SHIPPING_WIDTH.value <= 185) {
      RETOURE_PRICE = parseInt(SHIPPING_INFOS.retoure_surcharge_185);
    } else if (SHIPPING_WIDTH.value > 185 && SHIPPING_WIDTH.value <= 290) {
      RETOURE_PRICE = parseInt(SHIPPING_INFOS.retoure_surcharge_290);
    } else if (SHIPPING_WIDTH.value > 290) RETOURE_PRICE = 0;

    return RETOURE_PRICE;
  }
}


export const INSTANTIATE_SHIPPING_SECTION = SHIPPING_VALUES => {
  const PAYMENT_SECTION_ELEMENT = document.querySelector('[data-section="shipping"]');
  if (!PAYMENT_SECTION_ELEMENT) return;

  return new ShippingSection(PAYMENT_SECTION_ELEMENT, SHIPPING_VALUES);
}
